import { component } from "picoapp";
import { malomoTracking } from "../../utilities/fetchMalomoTrackingURL";

export const malomoLink = component((node: HTMLAnchorElement) => {
  async function handleClick(e: Event) {
    e.preventDefault();
    const orderNumber = node.dataset.orderNumber;
    const customerEmail = node.dataset.customerEmail;
    const baseUrl = new URL("https://api.gomalomo.com/orders");
    baseUrl.searchParams.append("number", orderNumber);
    baseUrl.searchParams.append("customer_email", customerEmail);

    try {
      const data = await malomoTracking(baseUrl);
      if (data.url) {
        window.open(data.url, "_blank");
      }
    } catch (e) {
      console.error(e);
    }
  }

  const trackingAnchorButton = node.querySelector("a");
  trackingAnchorButton.addEventListener("click", handleClick);
});
